<template>
  <div class="item-friends" @click="itemClick">
    <div class="left">
        <div class="img-box">
            <img v-if="avatar" :src="avatar" alt="头像">
        </div>
    </div>
    <div class="mid">
        <div class="name">{{friendName}}</div>
        <div class="time">{{time}}</div>
    </div>
    <div class="right">￥{{amount}}</div>
  </div>
</template>

<script>


export default {
  name: "FinaceItem",
  props:{
      avatar:String,
      friendName:String,
      time:String,
      amount:Number,
      friendId:Number
  },
  computed: {
  },
 mounted() {
  },
  methods: {
    itemClick(){
      this.$router.push({
        path: `/ShopFriendEarn?id=${this.friendId}`,
      })
    },
  },
};
</script>

<style lang="scss">
.item-friends {
  width: 100%;
  min-height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  .left{
    .img-box{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        box-sizing: border-box;
        border: 1px solid #575757;
        img{
          width: 100%;
          height: 100%;
        }
    }
  }
  .mid{
      min-width: 150px;
      padding-left: 6px;
      font-size: 0.8rem;
      line-height: 1rem;
      box-sizing: border-box;
      text-align: left;
      flex-grow: 2;
  }
  .right{
      min-width: 40px;
      text-align: right;
  }
  
}
</style>
